import React from 'react'
import { Banner, Text, Box, RadioButton } from '@sketch/components'
import { ParentAccessLevel } from '@sketch/modules-common'
import InvitePeople from 'modules/shares/modals/ShareSettingsModal/InvitePeople'
import { ShareWithoutVersion } from 'modules/versioning'
import { useUpdateShareParentPermissions } from 'modules/shares/modals/ShareSettingsModal/ParentPermissions/useUpdateShareParentPermissions'

export const WorkspaceMembersTitle = ({
  isProjectAvailableToWorkspace,
}: {
  isProjectAvailableToWorkspace: boolean
}) => (
  <>
    Workspace Members ({isProjectAvailableToWorkspace ? 'All' : 'Restricted'})
  </>
)

export const WorkspaceMembersPanel = ({
  share,
}: {
  share: ShareWithoutVersion
}) => {
  const {
    getUpdateShareParentPermissionsDropdownProps,
    shareParentAccessLevel,
  } = useUpdateShareParentPermissions({ share })

  const { setLevel } = getUpdateShareParentPermissionsDropdownProps()

  const viewOnly = shareParentAccessLevel === 'VIEW'
  const isProjectAvailableToWorkspace =
    !share.project || share.project?.workspaceAccessLevel === 'DEFAULT'
  const workspaceName = share.workspace.name

  const handleAccessLevelChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setLevel(e.target.value as ParentAccessLevel)

  return (
    <>
      {!isProjectAvailableToWorkspace && (
        <Box mb={6}>
          <Banner
            type="information"
            data-testid="sharing-workspace-restricted-banner"
          >
            This document is in a restricted project. Changing access options
            will only affect current project Members.
          </Banner>
        </Box>
      )}
      <Text textStyle="copy.primary.standard.F">
        Members of {workspaceName} can:
      </Text>
      <RadioButton
        name="accessLevel"
        label="Edit or view this document"
        checked={!viewOnly}
        value="DEFAULT"
        onChange={handleAccessLevelChange}
      />
      <RadioButton
        name="accessLevel"
        label="View this document on the web app"
        checked={viewOnly}
        value="VIEW"
        onChange={handleAccessLevelChange}
      />
      {!isProjectAvailableToWorkspace && (
        <>
          <Text textStyle="copy.primary.standard.F" pt={6}>
            Invite other {workspaceName} Workspace Members:
          </Text>
          <InvitePeople
            data-testid="sharing-workspace-invite"
            hideLabel
            share={share}
          />
        </>
      )}
    </>
  )
}
